/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const isTypeable = (item: unknown): item is { '@type'?: string | undefined } => {
  return typeof item === 'object' && item !== null && '@type' in item;
};
